<div (keypress)="readBarcode($event)">

    <div class="container">
        <div class="flex justify-between flex-wrap pt-8 pl-20 pr-20">

            <div class="">
                <h4>Enter tracknum:</h4>
                <input pInputText type="text" [value]="scanValue" autofocus readonly>
                <button pButton (click)="clearValue()" class="ml-1">Clear</button>
            </div>

            <div class="">
                <div class="">
                    <h4>Date:</h4>
                    <p-calendar [(ngModel)]="packageDate" name="packageDate" dateFormat="dd.mm.yy" [showTime]="true"
                        [iconDisplay]="'input'" [showIcon]="true"></p-calendar>
                </div>

                <div class="pt-2">
                    <p-button severity="warn" (click)="importShipment()" [disabled]="false">
                        <i class="fa fa-plane" aria-hidden="true"></i>
                        Bulk packages import
                    </p-button>
                </div>
            </div>
        </div>
    </div>

    <div class="p-6">
        <p-table [value]="tracknumbers" [tableStyle]="{ 'min-width': '40rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>#</th>
                    <th>Track code</th>
                    <th>Scanned time</th>
                    <th>Client code</th>
                    <th>Status</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-track>
                <tr>
                    <td class="text-white text-bold" [ngClass]="getStyleClass(track.state)">{{ track.rownum }}</td>
                    <td>{{ track.tracknum }}</td>
                    <td>{{ track.time | date: 'dd.MM.yyyy HH:mm:ss' }}</td>
                    <td>{{ track?.userInfo?.client_code ? track.userInfo.client_code : "no data"}}</td>
                    <td class="text-white text-bold" [ngClass]="getStyleClass(track.state)">{{getStateName(track.state)}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <p-dialog header="Bulk data reading" [(visible)]="showDialog" [modal]="true" [maximizable]="true"
        (onHide)="cancelImport()">
        <div class="p-fluid">
            @if(cargoFeatures?.isDestStorage) {
            <div class="field">
                <label for="cityToSend">Tracks for storage:</label>

                <p-dropdown [options]="cities" [(ngModel)]="selectedCity" optionLabel="name" [showClear]="true"
                    placeholder="Select a City" appendTo="body" id="cityToSend" optionValue="id">
                </p-dropdown>
            </div>
            }

            <div class="field">
                <label for="tracksData">Track nums:</label>
                <textarea id="tracksData" pInputText [(ngModel)]="tracksData" rows="10"
                    (ngModelChange)="checkReset()"></textarea>
            </div>
        </div>

        <p-footer>
            @if(cargoFeatures?.isWeightUpload) {
            <p-button size="small" (click)="bulkImport()" [disabled]="!tracksChecked">Bulk import</p-button>
            <p-button size="small" (click)="checkData()">Check weight data</p-button>
            } @else {
            <p-button size="small" severity="success" (click)="bulkImport()">Bulk import</p-button>
            }
            <p-button size="small" severity="warn" (click)="cancelImport()">Cancel</p-button>
        </p-footer>
    </p-dialog>
</div>